<template>
	<div>
		<div class="mobile">
			<!-- ... (template code) ... -->
			<div class="container-fluid top-header">
				<div class="row">
					<div class="col-2">
						<a href="#" data-bs-toggle="collapse" data-bs-target="#sub-sidebar" aria-expanded="false" aria-controls="sub-sidebar">
							<i class="fas fa-bars"></i>
						</a>
					</div>
					<div class="col-8">
						<Organisation v-if="refresh != 0" v-on:callback="getCallback" :key="refresh"></Organisation>
					</div>
					<div class="col-2">
						<div class="img-placeholder text-end">
							<i class="far fa-user-circle"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sidebar-container" v-bind:class="{'active' : toggleMainSidebar}">
			<div class="logo hide-mobile" data-bs-toggle="modal" data-bs-target="#vertexProduct" v-on:click="getHeaderSetting()">
				<img src="@/assets/img/logo-white.png" class="hide-toggle">
				<img src="@/assets/img/sublogo.png" class="toggle-img">
			</div>
			<div class="">
				<div class="navigation">
					<ul class="sidebar-nav main-ul">
						<li>
							<router-link :to="dashboardLink" class="d-flex align-items-center">
								<i class="fab fa-buromobelexperte"></i>
								<div class="ms-3 hide-toggle">Dashboard</div>
								<div class="caret hide-toggle"></div>
							</router-link>
						</li>
						<li>
							<router-link to="#" class="d-flex align-items-center">
								<i class="far fa-bell"></i>
								<div class="ms-3 hide-toggle">Notification</div>
								<div class="caret hide-toggle"></div>
							</router-link>
						</li>
						<li class="pe-3" v-if="isSuperAdmin || isPentester">
							<hr class="bg-light" />
							<sup class="text-light">Admin </sup>
						</li>
						<li v-if="isSuperAdmin || isPentester">
							<router-link to="/admin/category">
								<i class="fas fa-layer-group"></i>
								<div class="ms-3 hide-toggle">Categories</div>
								<div class="caret hide-toggle"></div>
							</router-link>
						</li>
						<li v-if="isSuperAdmin || isPentester">
							<router-link to="/admin/catalogue">
								<i class="far fa-copy"></i>
								<div class="ms-3 hide-toggle">Catalogue</div>
								<div class="caret hide-toggle"></div>
							</router-link>
						</li>
						<li v-if="isSuperAdmin || isPentester">
							<router-link to="/admin/settings">
								<i class="fas fa-cog"></i>
								<div class="ms-3 hide-toggle">Settings</div>
								<div class="caret hide-toggle"></div>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="account-menu pe-4 hide-mobile">
					<ul class="main-ul">
						<li class="mb-4">
							<Organisation v-on:callback="getCallback" :key="refresh"></Organisation>
						</li>
						<li class="dropup">
							<div data-bs-toggle="dropdown" data-bs-placement="top-end" aria-expanded="false" class="w-100">
								<div class="img-placeholder">{{ first_name.charAt(0) }}</div>
								<div class="hide-toggle">
									{{ first_name }}
								</div>
								<div class="float-end">
									<i class="text-end fa fa-chevron-right"></i>
								</div>
							</div>
							<ul class="dropdown-menu dropdown-menu-end sidebar-user-menu" aria-labelledby="dropDownlink">
								<li v-if="isSuperAdmin || isOrgAdmin">
									<a class="dropdown-item" href="javascript:void(0)" v-on:click="orgSetting()" id="toOrgSetting">Organisation Settings</a>
								</li>
								<li>
									<a class="dropdown-item" :href="this.$auth_ui + 'user-settings/'">My profile</a>
								</li>
								<li>
									<a class="dropdown-item" href="javascript:void(0)" v-on:click="logout()">Log out</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="subSidebar">
			<button type="button" id="refreshSidebar" v-on:click="init()" class="d-none"></button>
			<div class="main-collapse p-2 pt-3 hide-mobile" v-on:click="toggleMain">
				<i class="fa fa-bars"></i>			</div>
			<div class="subpad">
				<div class="hideshidebar"
					data-bs-toggle="collapse"
					data-bs-target="#sub-sidebar"
					aria-expanded="true"
					aria-controls="sub-sidebar"
					v-on:click="SubSidebarClick"
					v-bind:class="{'collapsed': !SubSidebar}"
					>
					<i class="fas fa-chevron-right"></i>
					<i class="fas fa-chevron-left"></i>
				</div>
				<div class="collapse collapse-horizontal collapse-sidebar" v-bind:class="{'show': SubSidebar}" id="sub-sidebar">
					<div class="row">
						<div class="col text-muted d-grid" v-if="selectedOrganisation">
							<router-link :to="`/${selectedOrganisation.id}/dashboard`" class="btn btn-link text-dark border">
								{{ selectedOrganisation.name || selectedOrganisation.organisation }}
							</router-link>
						</div>
						<div v-else>
							No organisation selected
						</div>
					</div>

					<a href="javascript:void(0)" id="reloadSidebar" v-on:click="init()"></a>
					<div class="accordion" id="accordionExample">
						<div class="accordion-item bg-transparent border-0"
							v-for="list in projectsList"
							:key="list.id">
							<div v-if="list.status != 3">
								<h2 class="accordion-header" :id="'heading'+list.id">
									<button
										class="accordion-button bg-transparent border-0"
										type="button"
										data-bs-toggle="collapse"
										:data-bs-target="'#collapse'+list.id"
										aria-expanded="true"
										:id="'accordion_button_'+list.id"
										:aria-controls="'collapse'+list.id"
										v-on:click="ActiveCollapse(list.id)">
										<i class="fas fa-plus me-2"
											data-bs-toggle="modal"
											data-bs-target="#submitVulnerability"
											v-if="isSuperAdmin || isPentester"
											v-on:click.stop="OpenReportForm(list.id, list.title)"></i>
											<span class="text-truncate">{{ list.title }}</span>
									</button>
								</h2>
								<div
									:id="'collapse'+list.id"
									class="accordion-collapse collapse"
									:class="{ 'show' : (activeProject == list.id) }"
									:aria-labelledby="'heading'+list.id"
									data-bs-parent="#accordionExample">
									<div class="accordion-body p-2">
										<ul class="sub-option">
											<li>
												<router-link :to="{ path: '/' + $route.params.org_id + '/dashboard/' + list.id, query: { project_name: list.title } }">
													<i class="far fa-id-card me-2"></i>Summary
												</router-link>
											</li>
											<li class="pb-2 pt-2" v-if="isSuperAdmin || isPentester">
												<a href="javascript:void(0)"
												data-bs-toggle="modal"
												data-bs-target="#submitVulnerability"
												v-on:click="OpenReportForm(list.id, list.title)">
													<i class="far fa-paper-plane me-2"></i> Submit
												</a>
											</li>
											<li>
												<router-link :to="{ path: '/' + $route.params.org_id + '/vulnerability/' + list.id, query: { project_name: list.title } }">
													<i class="fas fa-bug me-2"></i> Vulnerabilities
												</router-link>
											</li>
											<li
												v-if="isSuperAdmin || isPentester || (list.status == 2)">
												<router-link :to="{ path: '/' + $route.params.org_id + '/pdf/' + list.id, query: { project_name: list.title } }">
													<i class="far fa-file-pdf me-2"></i> Report
												</router-link>
											</li>
											<li
												v-if="isSuperAdmin || isPentester || (list.status == 2 && list.payment_status == 2)">
												<router-link :to="{ path: '/' + $route.params.org_id + '/certificate/' + list.id, query: { project_name: list.title } }">
													<i class="fas fa-award me-2"></i> Certificate
												</router-link>
											</li>
											<li
												class="pb-2"
												v-if="isSuperAdmin || isPentester">
												<router-link :to="{ path: '/' + $route.params.org_id + '/scan/' + list.id, query: { project_name: list.title } }">
													<i class="fas fa-search me-2"></i> Scan
												</router-link>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<!-- submit report -->
		<div class="modal" id="submitVulnerability" tabindex="-2" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h3>Submit vulnerability for <strong>{{ report_title }}</strong></h3>
						<button type="button" id="closeSubmitForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<Submit
							v-on:callback="submitCallback"
							:project_id="project_id"
							:report_id="report_id"
							:key="refresh"
							v-if="showReportForm" />
					</div>
				</div>
			</div>
		</div>

		<!-- browse to other application -->
		<div class="modal fade" id="vertexProduct" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Browse to other vertex products</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="row">
						<h2 v-if="applications.length == 0" class="text-center">No other products available</h2>
						<div class="col-md-6 mb-3" v-for="(item,index) in applications" :key="index">
							<div class="card">
								<a :href="item.url +'&org_selected=' + orgID" target="_blank" :title="item.application">
									<img :src="item.logo" :title="item.application" class="card-img-top">
								</a>
							</div>
						</div>
					</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import Organisation from '../components/Organisation.vue'
	import Submit from '../views/Project/Submit.vue'
	import { mapGetters, mapActions } from 'vuex';
	export default {
		name: 'sidebar',
		components: {
			Organisation,
			Submit
		},
		props: {
			settings: Object
		},
		data() {
			return {
				toggleMainSidebar: false,
				projectsList: {},
				org: '',
				sidebar: false,
				refresh: 0,
				project_id: 0,
				report_id: 0,
				SubSidebar: true,
				showReportForm: false,
				report_title: '',
				dashboardLink: '/dashboard',
				headerLink: {
					core: 'https://core.vertexcybersecurity.com.au/',
					pentester: '#',
					xsurflog: 'https://www.xsurflog.com/',
					soc: 'https://soc.vertexcybersecurity.com.au/'
				},
				activeProject: localStorage.getItem("SelectedProject"),
				applications:[],

			}
		},

		computed: {
			...mapGetters('auth', [
				'isSuperAdmin',
				'isPentester',
				'isOrgAdmin',
				'user',
			]),
			...mapGetters('organisation', ['selectedOrganisation', 'selectedOrgId']),
			orgID() {
				return this.selectedOrgId;
			},

			first_name() {
				// The user object now reliably comes from the Vuex store.
				return this.user?.first_name || '';
			}
		},

		watch:{
			$route: {
				immediate: true,
				async handler(to) {
					if (to.params.org_id == undefined) {
						this.showReportForm = false;
						// No need to clear org from session storage if we don't use it
						this.projectsList = {};
						localStorage.removeItem("SelectedProject");
						this.activeProject = null;
					} else {
						if (!this.selectedOrganisation || this.selectedOrganisation.id != to.params.org_id) {
							try {
								const response = await this.$axios.get(`${this.$server}organisation/${to.params.org_id}`);
								if (response.data.success && response.data.organisation) {
									this.selectOrganisationAction(response.data.organisation);
								}
							} catch (error) {
								console.error("Failed to fetch organisation data:", error);
								this.$toast.error("Could not load organisation details.");
							}
						}

						this.activeProject = localStorage.getItem("SelectedProject");
						// When route changes, ensure local `org` data is synced with the store
						this.org = this.selectedOrganisation;
						this.init();
					}
				}
			}
		},
		mounted() {
		},

		methods: {
			getHeaderSetting() {
				this.$axios.get(this.$server + 'settings/group/header_link')
				.then(res => {
					var r = res.data;
					if (r.success) {
						for (let i = 0; i < Object.keys(r.data).length; i++) {
							this.headerLink[r.data[i].title] = r.data[i].value;
						}
					}
				});
			},

			ActiveCollapse(id) {
				this.activeProject = id;
				localStorage.setItem("SelectedProject", id);
			},
			orgSetting() {
				const orgId = this.selectedOrgId;
				window.location.href = this.$auth_ui + (orgId ? `organisations/${orgId}/settings` : 'organisations');
			},

			logout() {
				this.logoutAction('You have been logged out.');
			},

			async getData() {
				try {
					const response = await this.$axios.get(this.$server+"/organisations/"+ this.orgID + "/products");
					if (response.data.success) {
						return response.data.products;
					} else {
						this.$toast.error(response.data.message);
						return null;
					}
				} catch (error) {
					this.$toast.error('An error occurred while fetching data.');
					return null;
				}
			},


			filterProducts(products) {
				this.applications = [];

				let newList = [];

				for (const product of products) {
					if (!product.application) continue;

					var name = product.application.toLowerCase()

					if (name == "pentester") continue
					if (newList.includes(name)) continue
					if (!product.organisation_product_id) continue

					const token = this.$store.state.auth.accessToken;
					let url = `${product.login_url}?access_token=${token}`

					let logo = ""
					switch (name) {
						case 'pentesting':
								logo = require('@/assets/img/product/pentester.png')
							break;
						case 'xsurflog':
								logo = require('@/assets/img/product/xsurflog.png')
							break;
						case 'soc':
								logo = require('@/assets/img/product/soc.png')
							break;
						case 'password manager':
								logo = require('@/assets/img/product/password_manager.png')
							break;
						case 'spark':
								logo = require('@/assets/img/product/spark.svg')
							break;
						case 'audit':
								logo = require('@/assets/img/product/audit.png')
							break;
						default:
								logo = require('@/assets/img/product/vertex-product-default.png')
							break;
					}

					this.applications.push(
						{
							'logo': logo,
							'application': product.application,
							'url': url
						}
					)
					newList.push(name)
				}
			},

			submitCallback(res) {
				if (res) {
					document.getElementById("closeSubmitForm").click();
					// this.$router.push({ path: '/' + this.$route.params.org_id + '/vulnerability/' + this.project_id});
				}
			},

			OpenReportForm(project_id, title) {
				this.project_id = project_id;
				this.report_title = title;
				this.refresh = Math.random();
			},

			SubSidebarClick() {
				setTimeout(() => {
					this.SubSidebar = !this.SubSidebar;
					localStorage.setItem("SubSidebar", this.SubSidebar);
				}, 500);
			},

			toggleMain() {
				if (this.toggleMainSidebar) {
					this.toggleMainSidebar = false;
				} else {
					this.toggleMainSidebar = true;
				}

				localStorage.setItem("mainMenu", this.toggleMainSidebar);
			},

			getCallback(org) {
				this.org = org;
				this.dashboardLink = "/" + org.id + "/dashboard";
			},

			async init() {
				// Sync local state with Vuex store
				this.org = this.selectedOrganisation;

				if (this.org) {
					this.dashboardLink = `/${this.org.id}/dashboard`;
					this.showReportForm = true;
				} else {
					this.showReportForm = false;
				}


				if (localStorage.getItem('mainMenu') != null) {
					this.toggleMainSidebar = JSON.parse(localStorage.getItem('mainMenu')); // to convert to boolean string false will return true
				}

				if (localStorage.getItem('SubSidebar') != null) {
					this.SubSidebar = JSON.parse(localStorage.getItem('SubSidebar'));
				}

				this.projectsList = JSON.parse(sessionStorage.getItem('org'));

				const data = await this.getData();
				this.filterProducts(data);
			},
			...mapActions('auth', {
				logoutAction: 'logout'
			}),
			...mapActions('organisation', {
				selectOrganisationAction: 'selectOrganisation'
			})
		}
	}
</script>